export const domainTrackMap = {
  "https://test.example.com": "Galot Motorsports Park",
  "https://qa.example.com": "Summit Motorsports Park",

  "https://timeslips-uat.microstrat-projects.com/editTrackEvent": "all tracks",
  "https://timeslips-uat.microstrat-projects.com/timeslip": "all tracks",
  "https://timeslips-uat.microstrat-projects.com/searchView": "all tracks",
  "https://timeslips-uat.microstrat-projects.com/watchlist": "all tracks",

  "https://raceresults.1320cc.com/editTrackEvent": "all tracks",
  "https://raceresults.1320cc.com/timeslip": "all tracks",
  "https://raceresults.1320cc.com/searchView": "all tracks",
  "https://raceresults.1320cc.com/watchlist": "all tracks",

  "http://localhost:3000/editTrackEvent" : "all tracks",
  "http://localhost:3000/timeslip" : "all tracks",
  "http://localhost:3000/searchView" : "all tracks",
  "http://localhost:3000/watchlist" : "all tracks",

  "https://tristate.results.1320cc.com": "Tri-State Raceway",
  "https://tristate.results.1320cc.com/": "Tri-State Raceway",
  "https://tristate.results.1320cc.com/editTrackEvent" : "Tri-State Raceway",
  "https://tristate.results.1320cc.com/timeslip" : "Tri-State Raceway",
  "https://tristate.results.1320cc.com/searchView" : "Tri-State Raceway",
  "https://tristate.results.1320cc.com/watchlist" : "Tri-State Raceway",

  "https://tristateresults.1320cc.com" : "Tri-State Raceway",
  "https://tristateresults.1320cc.com/" : "Tri-State Raceway",
  "https://tristateresults.1320cc.com/editTrackEvent" : "Tri-State Raceway",
  "https://tristateresults.1320cc.com/timeslip" : "Tri-State Raceway",
  "https://tristateresults.1320cc.com/searchView" : "Tri-State Raceway",
  "https://tristateresults.1320cc.com/watchlist" : "Tri-State Raceway",

  "https://srca.results.1320cc.com": "SRCA Dragstrip",
  "https://srca.results.1320cc.com/": "SRCA Dragstrip",
  "https://srca.results.1320cc.com/editTrackEvent" : "SRCA Dragstrip",
  "https://srca.results.1320cc.com/timeslip" : "SRCA Dragstrip",
  "https://srca.results.1320cc.com/searchView" : "SRCA Dragstrip",
  "https://srca.results.1320cc.com/watchlist" : "SRCA Dragstrip",
  

  "https://srcaresults.1320cc.com": "SRCA Dragstrip",
  "https://srcaresults.1320cc.com/": "SRCA Dragstrip",
  "https://srcaresults.1320cc.com/editTrackEvent" : "SRCA Dragstrip",
  "https://srcaresults.1320cc.com/timeslip" : "SRCA Dragstrip",
  "https://srcaresults.1320cc.com/searchView" : "SRCA Dragstrip",
  "https://srcaresults.1320cc.com/watchlist" : "SRCA Dragstrip",
};
